import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../assets/logo-3.3.png'
import { InstagramIcon, GithubIcon, LinkedInIcon, GmailIcon } from './Icon'

export function FooterLink({ link, text }) {
    return (
        <div className="footer">
            <div className="footer-link" >
                <div className='link-one'>
                    <h1>
                        <Link to={link[0]} target="_blank">{text[0]}</Link>
                    </h1>
                </div>
                <div className='link-two'>
                    <h1>
                        <Link to={link[1]} target="_blank">{text[1]}</Link>
                    </h1>
                </div>
            </div>
        </div >
    )
}

export function FooterSection() {
    return (
        <footer className="section-footer">
            <div className="copyright">
                <h1>Copyright Noxturne</h1>
            </div>
            <div className="footer-logo">
                <img src={Logo} alt="" />
            </div>
            <div className="socials">
                <ul>
                    <li>
                        <a href="https://www.instagram.com/clayzz1.0">
                            <InstagramIcon />
                        </a>
                    </li>
                    <li>
                        <a href="https://github.com/NoxturneDev">
                            <GithubIcon />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/in/galih-adhi-kusuma-693368240/">
                            <LinkedInIcon />
                        </a>
                    </li>
                    <li>
                        <Link to="/contact">
                            <GmailIcon />
                        </Link>
                    </li>
                </ul>
            </div>
        </footer>
    )
}